<template>
<v-card>
<v-toolbar   height="42"    color="#273C51" dark flat>
<v-toolbar-title>Добавить сообщества</v-toolbar-title>
<v-spacer></v-spacer> <v-icon @click="likes.modals.addSrc=false">mdi-close</v-icon>
</v-toolbar>




<v-textarea  v-model="srcList" color="#273C51" solo
label="Вставьте ids из буфера обмена"
placeholder="Список ids сообществ через запятую в одну строку или  каждое id с новой строки  (всего можно мониторить 25 сообществ)"
>
</v-textarea>




</v-card-text>

<v-card-actions>
<v-spacer></v-spacer>
<v-btn style="text-transform:none" @click="likes.modals.addSrc=false" small flat color="#273C51">Отменить</v-btn>
<v-btn style="text-transform:none" @click="srcAdd()" small color="#273C51"  class="white--text" > <v-icon left>mdi-plus</v-icon> Добавить</v-btn>
</v-card-actions>
</v-card>

</template>

<script>

import axios from 'axios'
export default {
props:['modals','likes'],
data () {
return {
srcList : ""
}
},
methods: {

srcAdd(){
this.likes.modals.addSrc = false

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/post_likes/src_add.php', {
method: 'POST',
data: {
list: this.srcList,
cat_id:this.likes.selectedCat.cat_id,
source_type:this.likes.selectedCat.params.source_type
}
})
.then( response => {
this.$router.go()
})
},
},

}
</script>

<style   >

</style>
